import type { Vehicle } from '../types/content'

/**
 * Vehicles Breezy owns outright. We have access to a wider network of trucks,
 * trailers and carts — these are the ones in house.
 */
export const fleet: Vehicle[] = [
  {
    slug: 'lil-breezy',
    name: 'Lil’ Breezy',
    length: '12′',
    use: 'Merch & sampling',
    markets: ['NYC', 'TX', 'CA', 'FL'],
    summary:
      'Our most nimble truck. Small enough for tight street permits and campus quads, built for merch drops and high-volume product sampling.',
    features: [
      'Merch window',
      'Shelving + product displays',
      'Power + audio',
      'Wrap-ready flat panels',
    ],
    render:
      'https://cdn.magicpatterns.com/uploads/tLPK83jPsaw3zZkYBormje/20250727_DJ_Adidas_093.jpg',
    fit: 'cover',
    gallery: [],
  },
  {
    slug: 'breezy-mambo',
    name: 'Breezy Mambo',
    length: '22′',
    use: 'Culinary & beverage',
    markets: ['CA'],
    summary:
      'The big one. A full-service kitchen on wheels for cocktail programs, chef collaborations and food-and-beverage led activations.',
    features: [
      'Full-service kitchen',
      'Cold storage',
      'Ideal for F&B programming',
      'Service window + awning',
    ],
    render:
      'https://cdn.magicpatterns.com/uploads/hLd9k1oRpBzaU82PdTmiSN/Mambo_truck.jpg',
    fit: 'cover',
    focus: 'center 66%',
    gallery: [],
  },
  {
    slug: 'big-breezy',
    name: 'Big Breezy',
    length: '18′',
    use: 'Food truck',
    markets: ['CA'],
    summary:
      'A production-ready food truck for sampling at scale — permitted, compliant and staffed for long service windows.',
    features: [
      '3-compartment sink',
      'Refrigeration',
      'Culinary production-ready',
      'Wide serving window',
    ],
    render:
      'https://cdn.magicpatterns.com/uploads/fkUsazQdVjStgEZxQC7wgn/Shake_shack_-_1.jpg',
    fit: 'cover',
    focus: 'center 68%',
    gallery: [],
  },
  {
    slug: 'ezzy',
    name: 'Ezzy',
    length: '15′',
    use: 'Versatile retail / merch',
    markets: ['NYC', 'CA'],
    summary:
      'A vintage-cab step van with a roomy interior — equally at home as a pop-up shop, a gifting suite or a photo moment.',
    features: [
      'Merch window',
      'Audio + power',
      'Spacious interior',
      'Vintage silhouette',
    ],
    render:
      'https://cdn.magicpatterns.com/uploads/5tXY3bwuRjDwvrU6h7me5X/38B22E49-05F3-44DF-9491-83565F83642F.jpg',
    fit: 'cover',
    focus: 'center 62%',
    gallery: [],
  },
]

export function getVehicle(slug: string) {
  return fleet.find((vehicle) => vehicle.slug === slug)
}
